import { auth, $can } from './plugin'

export function useAccess(prefix, actions) {
    const can = (...params) => $can(...params)

    can.permissions = auth.permissions
    can.can = prefix ? (...actions) => can(...actions.map((action) => prefix + action)) : can
    can.cans = actions?.map(prefix ? (action) => can(prefix + action) : can)
    return can
}
